import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const BookingsByDayChart = ({ data }) => {
  if (!data?.length) return <div style={{ padding: "32px", textAlign: "center", color: "#9CA3AF", fontSize: "14px" }}>No data available</div>;

  return (
    <ResponsiveContainer width="100%" height={240}>
      <BarChart data={data} barGap={4} barSize={18}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" vertical={false} />
        <XAxis dataKey="day" tick={{ fill: "#6B7280", fontSize: 12 }} axisLine={false} tickLine={false} />
        <YAxis tick={{ fill: "#6B7280", fontSize: 12 }} axisLine={false} tickLine={false} />
        <Tooltip
          contentStyle={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: "8px", fontSize: "12px" }}
          cursor={{ fill: "rgba(37,99,235,0.04)" }}
        />
        <Legend wrapperStyle={{ fontSize: "12px", color: "#6B7280" }} />
        <Bar dataKey="current"  name="This Period"     fill="#2563EB" radius={[4, 4, 0, 0]} isAnimationActive animationDuration={600} />
        <Bar dataKey="previous" name="Previous Period"  fill="#CBD5E1" radius={[4, 4, 0, 0]} isAnimationActive animationDuration={600} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BookingsByDayChart;
